<template>
  <div class="list-feed-header">
    <div class="list-feed-header__info">
      {{userName}}
    </div>
    <div class="list-feed-header__collapse" @click="onCollapse">
      <i :class="collapseIcon"></i>
    </div>
  </div>
</template>

<script>
  /*ListFeedHeader component*/

  export default {
    name: "ListFeedHeader",
    props: {
      userName: {
        type: String,
        required: true
      },
    },
    data() {
      return {
        collapse: false
      };
    },
    computed: {
      collapseIcon() {
        return this.collapse ? 'el-icon-caret-top' : 'el-icon-caret-bottom';
      },
    },
    methods: {
      onCollapse() {
        this.collapse = !this.collapse;
        this.$emit('onCollapse', {name: this.userName, collapse: this.collapse});
      }
    }
  };
</script>

<style>
  .list-feed-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .list-feed-header__info {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
  }

  .list-feed-header__collapse {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    cursor: pointer;
  }
</style>
